import UspCard from './UspCard'
import type { UspCardContent } from '../data/types'

interface UspSectionProps {
    usps: [UspCardContent, UspCardContent, UspCardContent, UspCardContent];
}

// Intro copy is identical on all four industry pages (content/unimo-industry-page-copy.md).
export function UspSection({ usps }: UspSectionProps) {
    return (
        <section className="pt-section-gap">
            <h2 className="text-2xl font-medium text-unimo-slate lg:text-4xl">Here&apos;s what you can do about it.</h2>
            <p className="mb-section-headline-gap-bottom mt-2 max-w-xl font-light text-unimo-slate lg:text-xl">
                Model, watch, and report on your site. No data engineers, no analysts. Just ask.
            </p>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-3">
                {usps.map((usp, index) => (
                    <UspCard key={usp.title} {...usp} position={index as 0 | 1 | 2 | 3} />
                ))}
            </div>
        </section>
    )
}

export default UspSection
